export const categories = [
  { id: '1', name: '恋爱', icon: 'ri-heart-line', count: 3250, slug: 'romance', description: '甜蜜浪漫的爱情故事，心动瞬间尽在恋爱分类' },
  { id: '2', name: '奇幻', icon: 'ri-magic-line', count: 2180, slug: 'fantasy', description: '魔法与异世界的奇幻冒险，想象力无极限' },
  { id: '3', name: '动作', icon: 'ri-sword-line', count: 1890, slug: 'action', description: '热血沸腾的战斗场面，肾上腺素飙升的刺激体验' },
  { id: '4', name: '悬疑', icon: 'ri-search-eye-line', count: 1560, slug: 'thriller', description: '扣人心弦的悬疑推理，层层剥开的真相' },
  { id: '5', name: '都市', icon: 'ri-building-line', count: 1420, slug: 'urban', description: '现代都市中的百态人生，真实的职场与生活故事' },
  { id: '6', name: '科幻', icon: 'ri-rocket-line', count: 980, slug: 'sci-fi', description: '未来世界的科技幻想，探索宇宙的无限可能' },
  { id: '7', name: '日常', icon: 'ri-sun-line', count: 1350, slug: 'slice-of-life', description: '温馨治愈的日常生活，平凡中的感动瞬间' },
  { id: '8', name: '历史', icon: 'ri-ancient-gate-line', count: 720, slug: 'historical', description: '穿越时空的历史故事，感受古代文化的魅力' },
  { id: '9', name: '恐怖', icon: 'ri-ghost-line', count: 650, slug: 'horror', description: '惊悚刺激的恐怖故事，挑战你的胆量极限' },
  { id: '10', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 1100, slug: 'comedy', description: '轻松愉快的搞笑漫画，让你笑到停不下来' },
];

export const categoryComics = [
  {
    id: 'c1',
    title: '她的私密生活',
    author: '金作家',
    category: '恋爱',
    rating: 4.8,
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20beautiful%20couple%20moment%2C%20soft%20pink%20pastel%20background%2C%20warm%20romantic%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20digital%20illustration%2C%20anime%20inspired%20style%20with%20delicate%20details&width=400&height=560&seq=hanman-cat-01&orientation=portrait',
    slug: 'her-secret-life',
    chapters: '89话',
    views: '1.2亿',
  },
  {
    id: 'c2',
    title: '甜蜜陷阱',
    author: '李甜蜜',
    category: '恋爱',
    rating: 4.5,
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20sweet%20couple%20scene%2C%20soft%20peach%20background%2C%20gentle%20romantic%20atmosphere%2C%20clean%20minimal%20composition%2C%20high%20quality%20digital%20art%2C%20anime%20style%20with%20warm%20lighting&width=400&height=560&seq=hanman-cat-02&orientation=portrait',
    slug: 'sweet-trap',
    chapters: '55话',
    views: '6800万',
  },
  {
    id: 'c3',
    title: '我的契约男友',
    author: '赵浪漫',
    category: '恋爱',
    rating: 4.4,
    status: '已完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20elegant%20couple%20in%20formal%20wear%2C%20soft%20champagne%20background%2C%20romantic%20and%20sophisticated%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20digital%20illustration%2C%20anime%20style&width=400&height=560&seq=hanman-cat-03&orientation=portrait',
    slug: 'contract-boyfriend',
    chapters: '全98话',
    views: '4900万',
  },
  {
    id: 'c4',
    title: '剑与魔法',
    author: '朴大神',
    category: '奇幻',
    rating: 4.9,
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20epic%20warrior%20with%20magical%20powers%2C%20mystical%20blue%20and%20green%20background%2C%20adventure%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20digital%20art%2C%20anime%20style%20with%20dramatic%20lighting&width=400&height=560&seq=hanman-cat-04&orientation=portrait',
    slug: 'sword-and-magic',
    chapters: '156话',
    views: '9800万',
  },
  {
    id: 'c5',
    title: '神之塔',
    author: 'SIU',
    category: '奇幻',
    rating: 4.9,
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20tower%20cover%2C%20mysterious%20tower%20in%20sky%2C%20epic%20fantasy%20setting%2C%20dark%20blue%20and%20gold%20background%2C%20grand%20scale%20composition%2C%20high%20quality%20digital%20illustration%2C%20anime%20style&width=400&height=560&seq=hanman-cat-05&orientation=portrait',
    slug: 'tower-of-god',
    chapters: '512话',
    views: '4300万',
  },
  {
    id: 'c6',
    title: '暗夜追踪',
    author: '李侦探',
    category: '悬疑',
    rating: 4.7,
    status: '已完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%2C%20noir%20detective%20scene%2C%20dark%20urban%20night%20atmosphere%2C%20mysterious%20moody%20lighting%2C%20clean%20composition%2C%20high%20quality%20digital%20art%2C%20anime%20style%20with%20shadows&width=400&height=560&seq=hanman-cat-06&orientation=portrait',
    slug: 'night-tracking',
    chapters: '全120话',
    views: '7200万',
  },
  {
    id: 'c7',
    title: '热血高校',
    author: '崔教练',
    category: '动作',
    rating: 4.6,
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20action%20cover%2C%20energetic%20sports%20scene%2C%20dynamic%20movement%2C%20warm%20golden%20background%2C%20youthful%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20digital%20art%2C%20anime%20style&width=400&height=560&seq=hanman-cat-07&orientation=portrait',
    slug: 'hot-blood-highschool',
    chapters: '67话',
    views: '5500万',
  },
  {
    id: 'c8',
    title: '重生之我是大明星',
    author: '金星光',
    category: '都市',
    rating: 4.7,
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20celebrity%20cover%2C%20glamorous%20star%20on%20stage%2C%20bright%20spotlight%20and%20sparkle%20effects%2C%20urban%20fashion%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20digital%20illustration%2C%20anime%20style&width=400&height=560&seq=hanman-cat-08&orientation=portrait',
    slug: 'reborn-star',
    chapters: '42话',
    views: '8500万',
  },
  {
    id: 'c9',
    title: '末日后记',
    author: '刘未来',
    category: '科幻',
    rating: 4.6,
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20post%20apocalyptic%20cover%2C%20futuristic%20ruins%20landscape%2C%20dark%20atmospheric%20lighting%2C%20survival%20theme%2C%20clean%20composition%2C%20high%20quality%20digital%20art%2C%20anime%20style%20with%20dramatic%20mood&width=400&height=560&seq=hanman-cat-09&orientation=portrait',
    slug: 'post-apocalypse',
    chapters: '33话',
    views: '6100万',
  },
  {
    id: 'c10',
    title: '便利店新星',
    author: '孙日常',
    category: '日常',
    rating: 4.3,
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20cozy%20convenience%20store%20scene%2C%20warm%20friendly%20atmosphere%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20high%20quality%20digital%20illustration%2C%20anime%20style&width=400&height=560&seq=hanman-cat-10&orientation=portrait',
    slug: 'convenience-star',
    chapters: '78话',
    views: '3800万',
  },
  {
    id: 'c11',
    title: '幽灵学园',
    author: '周恐怖',
    category: '恐怖',
    rating: 4.2,
    status: '已完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%2C%20haunted%20school%20setting%2C%20dark%20eerie%20atmosphere%2C%20ghostly%20presence%2C%20cool%20blue%20tones%2C%20clean%20composition%2C%20high%20quality%20digital%20art%2C%20anime%20style&width=400&height=560&seq=hanman-cat-11&orientation=portrait',
    slug: 'ghost-academy',
    chapters: '全65话',
    views: '2900万',
  },
  {
    id: 'c12',
    title: '穿越朝鲜',
    author: '韩历史',
    category: '历史',
    rating: 4.5,
    status: '连载中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20cover%2C%20traditional%20Korean%20palace%20setting%2C%20elegant%20historical%20costumes%2C%20warm%20amber%20lighting%2C%20cultural%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20digital%20illustration%2C%20anime%20style&width=400&height=560&seq=hanman-cat-12&orientation=portrait',
    slug: 'time-slip-joseon',
    chapters: '48话',
    views: '2100万',
  },
];